import { GetLanesResponse } from "../../hooks/react-query/outbound/useLanes";

export const mockLanesList = {
  default: [
    {
      laneId: 1,
      originSic: "ONT",
      laneType: "Regular",
      destinationSic: "EWR",
    },
    {
      laneId: 2,
      originSic: "ONT",
      laneType: "Regular",
      destinationSic: "LAX",
    },
    {
      laneId: 3,
      originSic: "ONT",
      laneType: "Regular",
      destinationSic: "SFO",
    },
    {
      laneId: 4,
      originSic: "ONT",
      laneType: "Regular",
      destinationSic: "BOS",
    },
  ],
} as const satisfies Record<string, GetLanesResponse>;
